import { cache, CACHE_KEYS } from 'tradera-utils/cache';

export default () => {
    const recent = cache.read(CACHE_KEYS.RECENTLY_VIEWED_ITEMS) || [];
    return {
        // Items by itemId
        cache: {},
        // List of item ids in ascending cache order (oldest first)
        cacheOrder: [],
        recent
    };
};
